import React, { Component } from 'react';
import { ErrorPage } from './ErrorPage/ErrorPage';

export default class ErrorHandler extends Component {
  constructor(props) {
    super(props);
    this.state = {
      hasError: false,
    };
  }

  static getDerivedStateFromError() {
    return {
      hasError: true,
    };
  }

  render() {
    return this.state.hasError ? <ErrorPage /> : this.props.children;
  }
}
